<template>
<div class="view">
  <loader v-if="loader"></loader>

  <background
    :image="brand.bg"
  ></background>

  <fixed-header
    :brand="brand.name"
    :logo="brand.logo"
  ></fixed-header>

  <main class="main">
    <div class="panel">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <div class="claim" ref="claim">
              <div class="claim__logo">
                <img :src="brand.logo" :alt="brand.name">
              </div>
              <div class="claim__brand">
                {{ brand.name }} － {{ brand.store }}
              </div>
              <div class="claim__desc">
                {{ $t('claim.claimDiscount') }}
                <br>
                {{ transaction.time | moment('M/D HH:mm') }} {{ $t('claim.spent') }} ${{ transaction.spend }}
              </div>
              <div class="claim__list">
                <div class="claim__list-item">
                  <div class="claim__item">{{ $t('claim.pointRewards') }}</div>
                  <div class="claim__amount">{{ point | properNumber }} {{ $t('claim.points') }}</div>
                </div>
              </div>
              <template v-if="action.type === 'url'">
                <div class="row narrow-gutters">
                  <div class="col">
                    <div class="claim__msg">{{ action.msg }}</div>
                  </div>
                  <div class="w-100"></div>
                  <div class="col">
                    <a class="btn btn-lg btn-block" :href="action.url" target="_blank">{{ $t('claim.downloadOcard') }}</a>
                  </div>
                </div>
              </template>
              <template v-if="action.type === 'web'">
                <div class="row narrow-gutters" v-if="transaction.valid === 0">
                  <div class="col">
                    <button class="btn btn-lg btn-block btn-secondary" v-on:click="claimed()">
                      {{ $t('claim.pointsRewarded') }}
                    </button>
                  </div>
                </div>
                <div class="row narrow-gutters" v-else-if="point === 0">
                  <div class="col">
                    <button class="btn btn-lg btn-block btn-secondary" v-on:click="claimed()">
                      {{ $t('claim.checkPoints') }}
                    </button>
                  </div>
                </div>
                <div class="row narrow-gutters" v-else-if="user === null">
                  <div class="col">
                    <button class="btn btn-lg btn-block" v-on:click="goLogin()"> {{ $t('claim.loginClaim') }}</button>
                  </div>
                </div>
                <div class="row narrow-gutters" v-else>
                  <div class="col">
                    <div class="claim__msg">{{ $t('claim.claimDesc', {
                      user: user.name,
                      cell: user.cell
                    }) }}</div>
                  </div>
                  <div class="w-100"></div>
                  <div class="col col-auto">
                    <button class="btn btn-lg btn-block btn-secondary" v-on:click="goLogout()">
                      {{ $t('claim.notMe') }}
                    </button>
                  </div>
                  <div class="col">
                    <button class="btn btn-lg btn-block" v-on:click="claim()">{{ $t('claim.confirm') }}</button>
                  </div>
                </div>
              </template>
              <template v-if="action.type === 'cell'">
                <div class="cell">
                  <div class="row narrow-gutters">
                    <div class="col">
                      <div class="cell__msg">
                        {{ action.msg }}
                      </div>
                    </div>
                  </div>
                  <template v-if="transaction.valid === 1">
                    <div class="cell__form">
                      <div class="row narrow-gutters">
                        <div class="col-5">
                          <div class="o-form__row">
                            <div class="o-form__icon">
                              <i class="material-icons">language</i>
                            </div>
                            <div class="o-form__content">
                              <div class="o-form__label">
                                {{ $t('claim.countryCode') }}
                              </div>
                              <div class="o-form__value">
                                <country-select
                                  class="cell-country"
                                  v-on:select-country="selectedCountry($event)"
                                  :defaultCountry="cellCountry"
                                ></country-select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-7">
                          <div class="o-form__row">
                            <div class="o-form__icon">
                              <i class="material-icons">phone</i>
                            </div>
                            <div class="o-form__content">
                              <div class="o-form__label">
                                {{ $t('claim.phone') }}
                              </div>
                              <div class="o-form__value">
                                <input type="tel" class="o-form__input" v-model="cell">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row narrow-gutters">
                      <div class="col">
                        <button class="btn btn-lg btn-block" v-on:click="claimByCell">
                          {{ $t('claim.collect') }}
                        </button>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="transaction.valid === 0">
                    <div class="row narrow-gutters">
                      <div class="col">
                        <button class="btn btn-lg btn-block" v-on:click="goActionURL">
                          {{ $t('claim.memberCenter') }}
                        </button>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
            <div class="claim__serial">
              {{ $t('claim.offerSerial') }} <span class="monospace">{{ transaction.serial }}</span>
            </div>
            <div class="claim__terms">
              {{ $t('claim.eMembershipDesc', {user: brand.name}) }}
              {{ $t('claim.personalDesc', {name: brand.name}) }}
              {{ $t('claim.acceptedOfTerms') }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </main>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import swal from 'sweetalert2';
import AwesomePhonenumber from 'awesome-phonenumber';

import Axios from '@/helpers/axios';
import Mixin from '@/mixins';

import Loader from '@/components/Loader.vue';
import Background from '@/components/Entry/Background.vue';
import FixedHeader from '@/components/Entry/Fixed-Header.vue';
import CountrySelect from '@/components/Entry/Country-Select.vue';

export default {
  name: 'Claim',
  mixins: [Mixin],
  data() {
    return {
      point: null,
      action: {},
      brand: {
        id: '',
        name: '',
        logo: '',
        bg: '',
        store: '',
      },
      transaction: {
        serial: '',
        time: '2017-01-01',
        vaild: '',
        spend: '',
      },
      user: null,

      cellCountry: 'TW',
      cell: '',
    };
  },
  computed: {
    ...mapState([
      'loader',
      'client',
    ]),
    cellInstance() {
      return new AwesomePhonenumber(this.cell, this.cellCountry);
    },
    isValidCell() {
      return (this.cellInstance.isValid() && this.cellInstance.isMobile());
    },
  },
  methods: {
    ...mapMutations([
      'setLoader',
    ]),
    goLogin() {
      this.setLoader(true);
      this.$router.push({
        name: 'Entry',
        params: {
          brand: this.brand.id.toLowerCase(),
        },
        query: {
          r: encodeURIComponent(window.location.href),
        },
      });
    },
    goLogout() {
      this.setLoader(true);
      this.logout();
      this.$router.push({
        name: 'Entry',
        params: {
          brand: this.brand.id.toLowerCase(),
        },
        query: {
          ...this.$route.query,
          r: encodeURIComponent(window.location.href),
        },
      });
    },
    claim() {
      const data = {
        p: this.client.phoneType,
        brand_id: this.$route.params.brand,
        dtk: this.client.dtk,
      };

      Axios({
        method: 'post',
        url: '/event/receivePoint',
        data: Object.assign(data, this.$route.query),
      })
        .then((response) => {
          if (response.data.code === 500) {
            this.$router.push({
              name: 'Points',
              params: {
                brand: this.brand.id.toLowerCase(),
              },
            });

            this.$root.$message.success(`${this.$i18n.t('claim.successfullyDesc', { count: this.$options.filters.properNumber(this.point) })}`);
          } else if (response.data.code === 495) {
            swal.fire({
              text: response.data.msg,
              confirmButtonText: this.$i18n.t('common.ok'),
            });
          }
        });
    },
    claimByCell() {
      if (!this.isValidCell) {
        swal.fire({
          text: this.$i18n.t('entry.common:mobileNumberIncorrect'),
          confirmButtonText: this.$i18n.t('common.back'),
        });

        return;
      }

      this.setLoader(true);

      const data = {
        p: this.client.phoneType,
        dtk: this.client.dtk,
        country_code: AwesomePhonenumber.getCountryCodeForRegionCode(this.cellInstance.getRegionCode()).toString(),
        cell: this.cellInstance.getNumber('significant'),
      };

      Axios({
        method: 'post',
        url: '/event/receivePointByCell',
        data: Object.assign(data, this.$route.query),
      })
        .then((response) => {
          if (response.data.code === 500) {
            swal.fire({
              text: this.action.join_msg,
              confirmButtonText: this.$i18n.t('claim.memberCenter'),
            })
              .then(() => {
                window.location.href = this.action.url;
              });
          } else if (response.data.code === 495) {
            swal.fire({
              text: response.data.msg,
              confirmButtonText: this.$i18n.t('common.ok'),
            })
              .then(() => {
                this.setLoader(false);
              });
          }
        });
    },
    claimed() {
      this.setLoader(true);
      this.$router.push({
        name: 'Entry',
        params: {
          brand: this.brand.id.toLowerCase(),
        },
        query: {
          rv: 'Points',
        },
      });
    },
    goActionURL() {
      window.location.href = this.action.url;
    },
  },
  mounted() {
    const data = {
      p: this.client.phoneType,
      dtk: this.client.dtk,
    };

    Axios({
      method: 'post',
      url: '/event/pointGive',
      data: Object.assign(data, this.$route.query),
    })
      .then((response) => {
        if (response.data.code === 500) {
          this.action = response.data.data.action;
          this.point = response.data.data.point;
          this.transaction = response.data.data.trans;
          this.brand.id = response.data.data.brand.brand_id;
          this.brand.name = response.data.data.brand.brand_name;
          this.brand.logo = response.data.data.brand.logo;
          this.brand.bg = response.data.data.brand.bg;
          this.brand.store = response.data.data.brand.store_name;
          this.user = response.data.data.user;
          document.title = `${this.brand.name} - ${this.$i18n.t('claim.claimPoints', { point: this.point })}`;
          this.setLoader(false);
          this.$refs.claim.classList.add('bounceIn');
        } else {
          swal.fire({
            text: response.data.msg,
            confirmButtonText: this.$i18n.t('common.ok'),
          });
        }
      });
  },
  components: {
    Loader,
    Background,
    FixedHeader,
    CountrySelect,
  },
};
</script>

<style lang="sass" scoped>
@import '../../../../assets/sass/compoments/o-panel.sass'
@import '../../../../assets/sass/compoments/o-form.sass'

.view
  width: 100%
  height: 100%

.main
  height: 100%
  color: white
  overflow-x: hidden

.claim
  margin: 0 -15px
  padding: 16px 16px 4px

  border-radius: 16px

  background-color: white

  color: #333

  animation-name: bounceIn
  animation-duration: 1s
  animation-fill-mode: both

  &__logo
    position: relative
    margin: -50px auto 8px
    width: 68px
    height: 68px
    padding: 2px
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .5)

    border-radius: 6px

    background-color: white

    &::after
      position: absolute
      top: 2px
      right: 2px
      bottom: 2px
      left: 2px
      z-index: 2

      border: .5px solid rgba(0, 0, 0, .1)
      border-radius: 5px

      content: ''

    img
      position: relative
      width: 64px
      height: 64px

      border-radius: 5px

  &__brand
    font-weight: bold
    font-size: 1.2081rem

  &__desc
    margin-bottom: 16px
    font-size: 0.875rem
    color: #8E8E8E

  &__list
    margin-bottom: 16px
    min-height: 80px
    display: flex
    flex-direction: column
    justify-content: center

    &-item
      display: flex
      justify-content: space-between
      align-items: center
      padding: 16px

      border-radius: 16px
      background-color: #F5F5F5

      &:not(:last-child)
        margin-bottom: 8px

  &__item
    flex-grow: auto

    font-weight: bold

  &__amount
    flex-grow: auto

    color: #8E8E8E
    font-size: 1.5rem

  &__msg
    font-size: 0.875rem
    color: #8E8E8E

  &__serial
    margin-top: 16px

    font-size: 0.75rem
    color: #8E8E8E

  &__terms
    margin-top: 8px

    font-size: 0.75rem
    color: #8E8E8E

    a
      color: currentcolor
      text-decoration: underline

.cell
  &__msg
    font-size: 0.875rem
    color: #8E8E8E


  &__form
    margin: 16px 0
    padding: 0 16px
    box-shadow: 0 1px 4px rgba(0, 0, 0, .25)

    border-radius: 16px

  .o-form__row
    padding: 6px 0

    text-align: left

  .o-form__input
    wdith: 100%
    max-width: 100%
    background-color: transparent

  .cell-country
    width: 100%
    padding: 1px 2px
    overflow: hidden

    border: none
    border-radius: 23px

    background-color: transparent
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAwCAYAAACooNxlAAAABGdBTUEAALGPC/xhBQAAAYxJREFUaAXt1T9ugzAUBnAMQ5Zmh1vwZ2qToVvVC+Qulao26aWabjkBp4gEe3bo+9JYslCRYgPCSJ8lBwh5j+cfthMEbBSgAAUoQAEKUIACFKAABShAAQpQgAIUcBHIsuxd+qNLrBlTFMVW+pv53ZznkcvDZQBfSqm99F0cx6e6rs+OebZt235LntckSVRVVSeXPGPGWIPIrDjIAD5uRaxcUTAzbhgPyCV5nn1ACW11pfC2E7MOw/DHZvmkaboxMTr5Zr20niGY1niTeKNG5XfPFGAI4FHirzND5xCgQ1mWe30919EaBIW6ogAjiiLsGWtzwL5goCYnEATaomgMCfUWA+NyBkHwvSiC8SQz4yghXmNgTAofQ1ue5/gL/uzkuTRN8yLLQS0FA/WPAoJEfSi4J837mfFX5sAlo5Pg2Ld85NbK/J1PG6hZlz4ftIfoJPrYg6JvB75joNBRQZCwD2UJGJOA/IeyFAzUPmnDRos+6UOYnAIUoAAFKEABClCAAhSgAAUoQAEKUGCQwC/1HLKALR1EkwAAAABJRU5ErkJggg==')
    background-size: 24px
    background-repeat: no-repeat
    background-position: right center

    font-weight: 700
    color: #333

    -webkit-padding-end: 24px
    appearance: none
    text-overflow: ellipsis
    white-space: nowrap

    &__container
      height: 44px

      border-radius: 23px 0 0 23px

      background-color: white

    &::after
      content: ''

    &:focus
      outline: none

@keyframes bounceIn
  from,
  20%,
  40%,
  60%,
  80%,
  to
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1)

  0%
    opacity: 0
    transform: scale3d(0.3, 0.3, 0.3)

  20%
    transform: scale3d(1.1, 1.1, 1.1)

  40%
    transform: scale3d(0.9, 0.9, 0.9)

  60%
    opacity: 1
    transform: scale3d(1.03, 1.03, 1.03)

  80%
    transform: scale3d(0.97, 0.97, 0.97)

  to
    opacity: 1
    transform: scale3d(1, 1, 1)

.bounceIn
  animation-delay: .75s
  animation-duration: .75s
  animation-name: bounceIn
</style>
